import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';
import { KioskContextService } from '@core/services/kiosk-context.service';

/** Loopback kiosk-server uses credentials from device.db; extra headers break CORS preflight. */
function isKioskServerLoopbackRequest(url: string): boolean {
  const base = environment.kioskServerBaseUrl?.replace(/\/$/, '') ?? '';
  if (!base) {
    return false;
  }
  return url === base || url.startsWith(`${base}/`);
}

export function deviceKeyInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const router = inject(Router);
  
  // Only apply interceptor if we're on a kiosk route
  const currentUrl = router.url;
  const isKioskRoute = currentUrl.includes('/kiosk');
  
  if (!isKioskRoute || isKioskServerLoopbackRequest(req.url)) {
    return next(req);
  }
  
  const kioskContextService = inject(KioskContextService);

  const deviceKey = kioskContextService.deviceKey();
  const context = kioskContextService.deviceContext();
  const deviceId = context?.kioskDevice?.deviceId;
  if (deviceKey && deviceId) {
    const clonedRequest = req.clone({
      setHeaders: {
        'X-Device-Id': deviceId,
        'X-Device-Key': deviceKey
      }
    });
    return next(clonedRequest);
  }
  
  return next(req);
}
